exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mini-program-audit-dialog .el-dialog__body{max-height:72vh;overflow-y:auto}", ""]);

// exports
